import React from 'react';
import Relay from 'react-relay';
import { injectIntl, defineMessages } from 'react-intl';
import { style } from 'glamor';

import { RED, BLACK } from 'depop/styles/colors';

import { trackLikeProduct, trackUnlikeProduct } from 'depop/utils/tracking';

import { loginConnector } from 'depop/connectors';

import Heart from 'depop/components/icons/Heart';

import LikeProductMutation from '../mutations/LikeProductMutation';

const messages = defineMessages({
  like: {
    id: 'LikeButton.Like',
    defaultMessage: 'Like',
  },
  unlike: {
    id: 'LikeButton.Unlike',
    defaultMessage: 'Unlike',
  },
});

class LikeButton extends React.Component {
  props: {
    product: Object,
    currentUser: Object,
    from: ?String,
    listIndex: ?String,
    openLogin: () => void,
  };

  static contextTypes = {
    relay: Relay.PropTypes.Environment,
  };

  handleClick = event => {
    const {
      currentUser,
      openLogin,
      product,
      from: source,
      listIndex,
    } = this.props;
    const { viewerMetadata, counters } = product;

    if (!currentUser) {
      openLogin();
      return;
    }

    const hasLiked = viewerMetadata && viewerMetadata.viewerHasLiked;

    event.preventDefault();

    const params = {
      username: product.seller.username,
      id: product.publicId,
      slug: product.slug,
      price: product.price.display,
      currency: product.price.currency,
      source,
      similarItemIndex: source === 'similar items' ? listIndex : undefined,
    };

    if (hasLiked) {
      trackUnlikeProduct(params);
    } else {
      trackLikeProduct(params);
    }

    this.context.relay.commitUpdate(
      new LikeProductMutation({
        product,
        viewerMetadata,
        counters,
        action: hasLiked ? 'unlike' : 'like',
      }),
    );
  };

  render() {
    const { product, intl } = this.props;
    const { viewerMetadata } = product;

    const hasLiked = viewerMetadata && viewerMetadata.viewerHasLiked;

    return (
      <a
        {...style({
          display: 'inline-block',
          width: 24,
          height: 24,
          color: hasLiked ? RED : BLACK,
          verticalAlign: 'middle',
          ':hover': {
            color: RED,
          },
        })}
        title={
          hasLiked
            ? intl.formatMessage(messages.unlike)
            : intl.formatMessage(messages.like)
        }
        href="javascript:;"
        onClick={this.handleClick}>
        <Heart filled={hasLiked} />
      </a>
    );
  }
}

export default Relay.createContainer(loginConnector(injectIntl(LikeButton)), {
  fragments: {
    currentUser: () => Relay.QL`
      fragment on User {
        id
        publicId
        username
      }
    `,
    product: () => Relay.QL`
      fragment on Product {
        ${Relay.Mutation.getFragment.call(LikeProductMutation, 'product')}
        viewerMetadata {
          ${Relay.Mutation.getFragment.call(
            LikeProductMutation,
            'viewerMetadata',
          )}
          viewerHasLiked
        }
        counters {
          ${Relay.Mutation.getFragment.call(LikeProductMutation, 'counters')}
        }
        publicId
        slug
        price {
          currency
          display
        }
        seller {
          username
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/components/LikeButton.js